import { __assign, __rest } from "tslib";
import * as React from 'react';
import { SvgIcon } from '../../components/SvgIcon';
import { useTheme } from '../../components/styles';
export var IconDirectionality;
(function (IconDirectionality) {
    /**
     * The specified icon is left-to-right specific.
     */
    IconDirectionality["LeftToRight"] = "LeftToRight";
    /**
     * The specified icon is right-to-left specific.
     */
    IconDirectionality["RightToLeft"] = "RightToLeft";
    /**
     * The specified icon is applicable to left-to-right and right-to-left locales.
     */
    IconDirectionality["All"] = "All";
})(IconDirectionality || (IconDirectionality = {}));
export default function createSvgIcon(icons, size) {
    return React.forwardRef(function (props, ref) {
        // exclude ref from props being passed to component to avoid collision with the ref type from forwardRef
        var refProp = props.ref, other = __rest(props, ["ref"]);
        var direction = useTheme().direction;
        var path = icons.LeftToRight;
        var isDirectional = true;
        if (icons.All) {
            path = icons.All;
            isDirectional = false;
        }
        else if (icons.RightToLeft && direction === 'rtl') {
            path = icons.RightToLeft;
            isDirectional = false;
        }
        return (React.createElement(SvgIcon, __assign({ fontSize: size, ref: ref, isDirectional: isDirectional }, other), path));
    });
}
//# sourceMappingURL=createSvgIcon.js.map